var _linearGradient, _ellipse, _linearGradient2, _path, _path2, _radialGradient, _path3, _linearGradient3, _path4, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _path5, _path6, _linearGradient4, _linearGradient5, _linearGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _linearGradient7, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _linearGradient8, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _linearGradient9, _path7, _path8, _path9, _linearGradient10, _path10, _linearGradient11, _path11, _linearGradient12, _path12, _linearGradient13, _path13, _linearGradient14, _path14, _linearGradient15, _path15, _linearGradient16, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanadaWestern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 60.888,
    y1: 59.364,
    x2: 33.57,
    y2: -1.766
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0d88d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#f6eabf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefffd"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 35,
    rx: 49,
    ry: 33.22,
    fill: "url(#a)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 58.897,
    y1: 70.292,
    x2: 40.872,
    y2: 0.093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1af64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4d895"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99 35.64c0 17.99-21.94 32.58-49 32.58S1 53.63 1 35.64 22.94 3.06 50 3.06s49 14.59 49 32.58z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.98 29.16c0 14.42-19.24 26.1-42.98 26.1-23.73 0-42.98-11.69-42.98-26.1 0-14.42 19.24-26.1 42.98-26.1 23.73 0 42.98 11.69 42.98 26.1z",
    fill: "#f7c240"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 50.112,
    cy: 35.094,
    r: 46.315,
    gradientTransform: "matrix(1 0 0 .6655 0 11.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#857344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#7c6a3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#645230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#3c2a17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#160400"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.94 35.09c0 16.85-20.52 30.52-45.83 30.52S4.28 51.95 4.28 35.09c0-16.85 20.52-30.52 45.83-30.52 25.31.01 45.83 13.67 45.83 30.52z",
    fill: "url(#c)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 46.09,
    y1: 11.592,
    x2: 55.831,
    y2: 64.998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#857344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#827147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b6b50"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.94 35.79c0 16.47-20.34 29.82-45.44 29.82-25.09 0-45.44-13.35-45.44-29.82S25.4 5.97 50.5 5.97c25.1.01 45.44 13.36 45.44 29.82z",
    fill: "url(#d)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 4.822,
    cy: 34.88,
    r: 3.204,
    gradientTransform: "matrix(1 0 0 3.2909 0 -79.906)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#b08525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#b18626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#e1af64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#e7bd75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#f4d895"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M6.3 23.12s-3.69 4.52-4.25 10.59 5.04 12.48 4.09 9.99c-.85-2.23-2.64-5.91-1.85-12.04.54-4.22 5.24-11.66 2.01-8.54z",
    fill: "url(#e)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 3.61,
    cy: 31.677,
    r: 3.399,
    gradientTransform: "matrix(1 0 0 2.884 0 -59.679)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#fefffd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#f0d578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#e1af64"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M4.28 30.27s-1.23 2.12-1.01 4.98-1.04 3.28-1.15 1.12 1.15-6.77 2.16-7.55c1.01-.79.55.14 0 1.45z",
    fill: "url(#f)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 32.518,
    cy: 61.956,
    r: 9.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#fefffd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#f0d578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#e1af64"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M19.43 58.82s8.51 4.59 16.05 6.04c7.54 1.46 10.52.75 10.52.75s-11.72-1.38-17.87-3.86c-6.16-2.48-10.46-4.83-8.7-2.93z",
    fill: "url(#g)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 74.647,
    cy: 55.902,
    r: 15.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#f7e8bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#f0d578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#e1af64"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M54.88 65.78s17.7-.14 26.88-6.74 12.65-12.43 12.65-12.43-.63-1.34-1.44 0c-.8 1.35-8.54 16.4-38.09 19.17z",
    fill: "url(#h)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 92.86,
    cy: 25.026,
    r: 18.364,
    gradientTransform: "matrix(.3175 .9483 -.2916 .0976 70.678 -65.474)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#fefffd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#f0d578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    stopColor: "#b08525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#b18626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#e1af64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#e8bf77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#f4d895"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.75 18.44s8.98 6.12 8.69 14.7c-.29 8.57-2.46 7.52-2.5 5.67s1.05-6.11-1.53-12.45c-2.66-6.56-7.62-8.79-4.66-7.92z",
    fill: "url(#i)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m65.95 42.89-.83-1.41-2.82 1.41V27.81l-.82-1.41-1.17 1.37H50.3L38.16 42.89l-.82 6.87.82.9h15.2l-.83 3.95.83 1.42h8.94v-5.36h3.65v-7.78zm-17.58 0 5-7.64v7.64h-5zm45.4-4.58-.02.01.03-.44c-.02-5.96-6.12-10.78-13.62-10.76S66.58 32 66.6 37.96c.02 5.16 4.58 9.44 10.67 10.5l-7.56 5.39.82 1.42 13.06-.04c4.5-5.35 10.74-9.6 10.18-16.92zM80.5 42.49c-2.13.01-3.86-1.67-3.87-3.76-.01-2.08 1.71-3.77 3.85-3.78 2.13-.01 3.86 1.68 3.87 3.76 0 2.08-1.72 3.77-3.85 3.78zm-44.25.91c-.59-8.02-6.64-7.35-10.65-8.01l8.19-6.65v-.93l-.82-1.41-12.22 1.41c-4.46 5.28-10.58 9.48-10.25 16.64a9 9 0 0 0 .12 2.53c1.14 5.92 7.76 9.55 14.89 8.94 7.81-.68 11.28-5.17 10.74-12.52zM23.1 48.42c-2.14 0-3.86-1.69-3.86-3.78s1.73-3.78 3.86-3.78 3.86 1.69 3.86 3.78-1.73 3.78-3.86 3.78z",
    fill: "#200200"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 51.232,
    y1: 54.601,
    x2: 51.232,
    y2: 26.35
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#d2a436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#e8ae2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#fefdf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#faf7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#f5edbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#ede093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#e7ac2a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.13 41.47h-3.65V26.39h-2.05l.05-.04H49.47L37.34 41.47v7.77h15.2v5.36h8.94v-5.36h3.65v-7.77zm-17.59 0 5-7.64v7.64h-5z",
    fill: "url(#j)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 79.371,
    y1: 53.849,
    x2: 79.371,
    y2: 25.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#d2a436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#e8ae2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#fefdf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#faf7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#f5edbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#ede093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#e7ac2a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m92.94 36.89-.02.01.03-.44c-.02-5.96-6.12-10.78-13.62-10.76s-13.58 4.88-13.56 10.84c.02 5.16 4.58 9.44 10.67 10.5l-6.73 5.89v.92l13.05-.04c4.5-5.35 10.74-9.59 10.18-16.92zm-13.26 4.18c-2.13.01-3.87-1.67-3.87-3.76-.01-2.08 1.71-3.77 3.85-3.78 2.13-.01 3.86 1.68 3.87 3.76 0 2.08-1.72 3.78-3.85 3.78z",
    fill: "url(#k)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 22.554,
    y1: 54.565,
    x2: 22.554,
    y2: 26.393
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#d2a436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#e8ae2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#fefdf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#faf7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#f5edbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#ede093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#e7ac2a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M35.43 41.98c-.59-8.02-6.64-7.35-10.66-8.01l8.19-6.65v-.93H19.91c-4.46 5.28-10.58 9.48-10.25 16.64a9 9 0 0 0 .12 2.53c1.14 5.92 7.76 9.55 14.89 8.94 7.83-.68 11.3-5.17 10.76-12.52zm-13.16 5.03c-2.14 0-3.86-1.69-3.86-3.78s1.73-3.78 3.86-3.78 3.86 1.69 3.86 3.78-1.73 3.78-3.86 3.78z",
    fill: "url(#l)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 16.449,
    cy: 38.064,
    r: 6.628,
    gradientTransform: "matrix(1 0 0 .7371 0 10.009)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#b08525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#b98d29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#f4c953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#eddb85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#ecde8e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m17.13 35.51-2.43.13s-3.36 2.47-3.58 4.83.95 3.41 3.36 3.24 6.46-3.89 7.27-5.96c.71-1.79-4.62-2.24-4.62-2.24z",
    fill: "url(#m)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 16.307,
    cy: 37.845,
    r: 3.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#fcf9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#f4eabb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3e9b7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13.3 36.09s-1.23 4.31 2.35 4.11c3.58-.19 5.04-2.5 5.04-2.5s2.05-3.85-1.25-4.19c-3.31-.33-4.02 1.01-6.14 2.58z",
    fill: "url(#n)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 29.794,
    cy: 38.033,
    r: 8.638,
    gradientTransform: "matrix(1 0 0 .6833 0 12.044)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#b08525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#b98d29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#f4c953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#eddb85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#ecde8e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M22.55 37.4s3.04 2.81 4.41 5.09c1.24 2.07 7.1 2.24 8.47-.51.34-.68-1.74-4.19-1.91-4.19s-10.97-.39-10.97-.39z",
    fill: "url(#o)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 27.112,
    cy: 40.358,
    r: 7.402,
    gradientTransform: "matrix(1 0 0 .7507 0 10.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#fcf9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#f4eabb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3e9b7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M32.05 40.2s-2.27.81-4.46-.36c-2.2-1.17-2.31-1.54-4.16-1.72s-2.24-1.24-.84-1.58c1.4-.33 6.63-.96 8.93-.17 2.29.79 2.99 3.09.53 3.83z",
    fill: "url(#p)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 22.559,
    y1: 26.587,
    x2: 23.231,
    y2: 28.826
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#ad8132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#dbaa3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#f7c240"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m17.55 31.17 3.92-4.09 8.25.23s-.3.32-1.25.38-6.16.67-8.31 2.21c-2.16 1.55-3.62 3.06-2.61 1.27z",
    fill: "url(#q)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 45.434,
    cy: 35.932,
    r: 7.038,
    gradientTransform: "matrix(.7897 .6135 -.8735 1.1243 40.942 -32.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#b08525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#b98d29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#f4c953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#eddb85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#ecde8e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M49.41 38.12s-2.51 5.94-4.53 5.59-5.79-.82-4.54-2.5c.71-.95 2.24-3.87 2.24-3.87s7.4-.15 6.83.78z",
    fill: "url(#r)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 45.106,
    cy: 38.827,
    r: 4.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#fcf9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#f4eabb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3e9b7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M49.83 36.45c-.07.13-1.31 2.07-2.41 1.66-1.1-.4-.86.43-2.54 1.16-1.69.73-3.93.03-2.31-1.94s1.49-1.67 3.35-2.13c1.86-.45 4.79-.4 3.91 1.25z",
    fill: "url(#s)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 57.703,
    cy: 37.328,
    r: 7.611,
    gradientTransform: "matrix(1 0 0 .6732 0 12.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#b08525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b98d29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#f4c953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#eddb85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#ecde8e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M61.41 38.47s.99 5.24-3.16 5.24c-2.91 0-4.27-.65-4.71-4.02-.28-2.1.01-4.53 2.64-4.48 2.63.04 5.49 1.85 5.23 3.26z",
    fill: "url(#t)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 57.289,
    cy: 38.817,
    r: 5.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#fcf9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#f4eabb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3e9b7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M61.41 35.51s.9 2.98-3.1 3.27c-1.8.13-4.57-.34-4.75-2.32-.18-1.99.94-2.29 1.84-2.3.89-.03 5.5-.24 6.01 1.35z",
    fill: "url(#u)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 51.123,
    y1: 25.731,
    x2: 52.584,
    y2: 28.521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#ad8132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#e1af3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#f7c240"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m46.83 31.5 4.03-4.42h8.29s.08.61-2.62.73c-2.7.11-4.47-.31-6.52 1.72-2.06 2.03-2.61 3.09-3.18 1.97z",
    fill: "url(#v)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 71.718,
    cy: 37.19,
    r: 6.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#b08525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#b98d29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#f4c953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#eddb85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#ecde8e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M75.02 37.71s5.17 6-1.54 6c-4.77 0-6.22-3.77-5.77-6s6.96-.86 7.31 0z",
    fill: "url(#w)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 71.197,
    cy: 37.68,
    r: 3.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#fcf9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#f4eabb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3e9b7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M75.02 36.09s-.15 3.36-2.39 3.69c-2.24.34-4.78-1.46-4.99-2.8s.25-3.08 2.87-3.41c2.63-.33 4.51.91 4.51 2.52z",
    fill: "url(#x)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "y",
    cx: 88.868,
    cy: 36.092,
    r: 6.763,
    gradientTransform: "matrix(.9816 .1912 -.2183 1.1206 9.516 -21.341)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#b08525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#b98d29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#f4c953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#eddb85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#ecde8e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M92.04 36.99s2.49 6.21-3.66 7.61c-4.94 1.13-4.65-5.58-3.54-7.27 1.12-1.69 5.69-1.58 7.2-.34z",
    fill: "url(#y)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "z",
    cx: 88.055,
    cy: 38.214,
    r: 5.543,
    gradientTransform: "matrix(1 0 0 .8007 0 7.617)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#fcf9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#f4eabb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3e9b7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M84.84 36.09s2.22-1.42 5.13-.84 2.42 2.28 1.81 3.18a2.88 2.88 0 0 1-3.86.84c-1.73-.95-1.14-1.21-2.18-1.44-1.05-.22-1.79-.84-.9-1.74z",
    fill: "url(#z)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 80.866,
    y1: 26.353,
    x2: 80.866,
    y2: 30.084
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#ad8132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#b48733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#d1a139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#e6b33d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#f3be3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#f7c240"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.64 29.26s1.68-2.18 7-2.18 6.94 1.62 8.28 2.82c1.35 1.2 1.51 1.76 1.51 1.76s-4.37-3.75-9.41-3.58-6.38 1.15-6.89 1.44c-.49.3-1.28.42-.49-.26z",
    fill: "url(#A)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m53.36 35.25-.82 1.26v4.96h-3.25l-.92 1.42h4.99zm8.94 7.64h2.83v-1.42h-3.72zm-24.14 0L50.3 27.77h10.01l-.06.04h1.23v-1.42h-2.05l.05-.04H49.47L37.34 41.47v7.77h.82zm15.2 7.77-.82-.9v4.84h.82zm27.14-8.17c2.13-.01 3.85-1.7 3.84-3.78 0-.97-.39-1.85-1.02-2.52.11.35.19.72.19 1.1.01 2.08-1.71 3.77-3.84 3.78a3.89 3.89 0 0 1-2.86-1.24c.5 1.54 1.96 2.66 3.69 2.66zm-3.24 5.97c-.66-.12-1.3-.27-1.92-.46l-5.64 4.93v.92h1.39l6.17-5.39zm-10.67-10.5c-.02-5.96 6.06-10.82 13.56-10.85 5.1-.02 9.55 2.21 11.89 5.51-1.96-4.06-6.91-6.95-12.71-6.93-7.5.02-13.58 4.88-13.56 10.84 0 1.88.62 3.65 1.7 5.18a8.72 8.72 0 0 1-.88-3.75zm-55.98 9.02c-.16-.86-.19-1.7-.12-2.53-.34-7.16 5.79-11.36 10.25-16.64h11.63l.6-.49v-.93H19.91c-4.46 5.28-10.58 9.48-10.25 16.64a9 9 0 0 0 .12 2.53c.25 1.32.79 2.51 1.53 3.58a8.81 8.81 0 0 1-.7-2.16zm24.03-8.49c-1.49-3.42-4.72-3.92-7.64-4.24l-1.4 1.14c2.89.47 6.84.26 9.04 3.1zM23.1 48.42c2.13 0 3.86-1.69 3.86-3.78 0-.98-.39-1.87-1.02-2.54.11.36.19.73.19 1.13 0 2.09-1.73 3.78-3.86 3.78-1.13 0-2.13-.48-2.84-1.24a3.841 3.841 0 0 0 3.67 2.65z",
    fill: "#fffee8"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.02 16.76c.08.01.18.01.32.01l.43.01h1.49l.59-.03-.01.36c-.01.12-.03.24-.08.36-.15.02-.28.05-.38.09a.42.42 0 0 0-.23.19c-.06.09-.09.22-.11.39-.02.18-.04.4-.04.67v4.23c-.15.04-.32.06-.49.07l-.6.01-4.06-4.26v2.16c0 .27.01.48.04.65.02.16.07.29.14.38.07.1.17.17.29.21.13.04.28.07.47.09.04.1.06.22.07.34a4.82 4.82 0 0 1 .01.38c-.08-.01-.18-.01-.31-.01-.12 0-.25-.01-.38-.01l-.41-.01h-.35c-.1 0-.23 0-.38-.01h-.84l-.3.01a3.97 3.97 0 0 1 .02-.38 1.25 1.25 0 0 1 .08-.32 2.34 2.34 0 0 0 .46-.09c.12-.04.22-.11.3-.21a.95.95 0 0 0 .16-.38c.04-.17.05-.38.05-.65v-3.1l-.16-.18a.554.554 0 0 0-.26-.18c-.11-.03-.29-.06-.55-.08a1.14 1.14 0 0 1-.08-.33l-.02-.39c.08.01.18.01.32.01a5.89 5.89 0 0 0 .43.01h1.53l.36-.01.29-.01 3.27 3.5v-1.46c0-.26-.01-.48-.04-.64a.68.68 0 0 0-.13-.37c-.07-.09-.18-.17-.31-.21s-.3-.07-.52-.09a1.21 1.21 0 0 1-.07-.36l-.01-.36zm-7.33 5.52a.77.77 0 0 1-.25-.1 1.3 1.3 0 0 1-.23-.18l-.24-.3-.45-.6c-.13-.16-.25-.28-.37-.38a1.26 1.26 0 0 0-.39-.22 1.34 1.34 0 0 0-.26-.08l.39-.1c.29-.1.55-.23.76-.39.22-.17.39-.37.51-.6.13-.24.19-.51.19-.83a1.19 1.19 0 0 0-.2-.67c-.13-.21-.33-.4-.6-.55-.27-.16-.61-.28-1.03-.37-.42-.1-.91-.14-1.49-.14l-1.61.03-1.14.02c-.46 0-.89 0-1.28-.01l-1-.03c0 .03.01.08.01.14.01.06.01.13.01.2.01.07.01.14.03.21l.04.17a2.13 2.13 0 0 1 .45.07c.11.04.21.08.27.16a.52.52 0 0 1 .13.29 3.15 3.15 0 0 1 .04.5v2.83c0 .21-.01.38-.04.51-.02.13-.06.23-.13.31-.06.08-.16.12-.27.16a1.72 1.72 0 0 1-.44.05c-.04.08-.06.19-.08.3-.02.12-.03.26-.03.42l.99-.02 1.07-.01h.55l.66.01.63.01.48.01-.01-.41a.729.729 0 0 0-.08-.31l-.3-.04c-.08-.02-.14-.08-.2-.15a.795.795 0 0 1-.11-.34c-.02-.15-.04-.35-.04-.6v-.57h.51l.17.09c.1.06.19.14.27.23.09.08.17.19.24.31.08.12.16.27.26.44a8.25 8.25 0 0 1 .39.72l.34.69 1.17-.06 1.87-.02c.09-.23.14-.47.14-.73-.09-.04-.21-.05-.3-.07zm-3.23-3.22a1.03 1.03 0 0 1-.33.25c-.13.07-.29.12-.47.16a3.17 3.17 0 0 1-.53.05c-.06 0-.12 0-.19-.01-.04 0-.11 0-.19-.01v-1.67a3.07 3.07 0 0 1 .53-.05c.4 0 .72.08.96.23.23.16.35.38.35.68a.56.56 0 0 1-.13.37zm-21.84-1.58h-.02c-.44 0-.77.1-1 .29-.22.19-.4.49-.53.89-.23 0-.45-.01-.66-.02-.22-.02-.41-.05-.58-.12a3.44 3.44 0 0 0 .11-.41l.1-.46c.03-.16.05-.31.06-.47l.03-.43.74.01.79.01H53l.82-.01.76-.01c0 .26.03.55.08.86.05.32.12.62.21.89-.16.05-.35.09-.56.11l-.7.04c-.11-.41-.26-.71-.45-.9s-.49-.29-.9-.29h-.24v3.83c0 .21.01.38.05.51.03.13.09.23.17.31s.21.12.35.16c.16.03.35.05.6.05.04.08.07.2.09.33a2.77 2.77 0 0 1 .03.39l-.96-.02-1.38-.01h-.79l-.78.01-.7.01-.51.01a1.82 1.82 0 0 1 .04-.38c.03-.14.06-.26.11-.34l.62-.05c.16-.03.29-.08.39-.16s.17-.18.21-.31a1.78 1.78 0 0 0 .06-.51v-3.81zm-7.38-.77c.55 0 1.04.03 1.47.1s.75.15.97.24l.02.82c.01.27.04.49.07.64-.19.08-.41.12-.7.15a6.96 6.96 0 0 1-.74.04c-.05-.25-.11-.46-.2-.62-.08-.16-.18-.29-.29-.38a.95.95 0 0 0-.39-.19c-.14-.04-.31-.05-.48-.05a1.37 1.37 0 0 0-.61.14c-.18.09-.27.23-.27.42 0 .2.1.36.31.49s.47.25.77.36l1.01.34a5.19 5.19 0 0 1 1.02.42c.31.17.57.37.78.62s.31.55.31.92c0 .3-.09.57-.25.81s-.4.44-.7.61-.65.3-1.05.4a6.1 6.1 0 0 1-1.33.14c-.33 0-.63-.01-.89-.03l-.72-.09a4.47 4.47 0 0 1-.63-.16 7.33 7.33 0 0 1-.65-.23c.07-.26.11-.52.13-.79l.04-.78a6.06 6.06 0 0 1 .76-.1l.77-.01c.03.29.06.52.11.71.04.18.11.33.21.44a.85.85 0 0 0 .38.22 2.47 2.47 0 0 0 .6.07c.31 0 .58-.06.78-.17.21-.12.32-.27.32-.46s-.1-.34-.29-.45c-.19-.12-.43-.23-.72-.33l-.95-.33c-.33-.12-.65-.27-.95-.45a2.43 2.43 0 0 1-.72-.67c-.19-.27-.29-.6-.29-1.02a1.29 1.29 0 0 1 .24-.78c.16-.22.37-.4.64-.55a3.63 3.63 0 0 1 .95-.34 5.43 5.43 0 0 1 1.16-.12zm-5.89.05c0 .12.01.25.02.4l.05.44.07.44c.03.14.06.26.1.37-.16.05-.32.09-.49.12-.18.03-.4.05-.67.05a2.76 2.76 0 0 0-.15-.46.958.958 0 0 0-.27-.33 1.16 1.16 0 0 0-.46-.22c-.18-.05-.42-.08-.7-.08h-.56v2.1a1.96 1.96 0 0 0 .46-.04c.12-.02.21-.06.28-.11s.11-.12.15-.2c.03-.08.04-.19.04-.31.13-.04.29-.08.47-.09l.54-.02-.04.47-.01.6.01.64.04.46c-.21 0-.4 0-.55-.02a1.49 1.49 0 0 1-.43-.08c-.03-.25-.11-.42-.24-.5s-.38-.12-.72-.12v.99c0 .22.01.39.04.54.03.14.08.25.14.33.07.08.16.14.28.17.11.04.26.05.44.05h.19c.39 0 .69-.1.92-.3s.42-.52.57-.96c.26.02.49.06.7.12a1.64 1.64 0 0 1 .47.2c-.09.22-.15.47-.22.77a6.58 6.58 0 0 0-.13.89c-.17 0-.38 0-.62-.01-.25 0-.5-.01-.77-.01l-.84-.01h-.77l-.82.01-1.06.01-1.01.01-.66.01c0-.14.01-.27.02-.4s.03-.24.07-.32c.15-.01.28-.03.38-.05.1-.03.18-.08.24-.16s.1-.18.11-.31c.02-.13.03-.3.03-.51V18.5c0-.21-.01-.38-.03-.5a.59.59 0 0 0-.11-.29c-.06-.07-.14-.12-.24-.15s-.23-.05-.39-.08c-.03-.09-.05-.21-.06-.35l-.01-.37.64.01.8.01h3.58l.66-.01a4.47 4.47 0 0 0 .52-.01zm-19.46 0c.09.01.22.01.4.01l.54.01h1.81l.55-.01.47-.01-.01.38c-.01.12-.04.23-.07.34a1.59 1.59 0 0 0-.4.09c-.09.04-.16.1-.19.18-.04.08-.04.18-.01.31a2.84 2.84 0 0 0 .18.5l.45 1.14.27.7 1.5-3.62c.14-.03.29-.05.46-.06l.47-.01.56 1.14.51 1.06.5 1.08.24.53.61-1.72a3.11 3.11 0 0 0 .15-.58c.01-.16 0-.29-.05-.39a.43.43 0 0 0-.23-.23 1.87 1.87 0 0 0-.43-.12.95.95 0 0 1-.09-.35l-.02-.37c.08.01.17.01.28.01.11.01.23.01.36.01h1.31c.11-.01.22-.01.32-.01l.27-.01-.01.36a1.19 1.19 0 0 1-.09.36c-.11.03-.19.08-.27.13s-.16.13-.23.22c-.06.1-.14.22-.2.38l-.23.6-1.43 4.23-.23.04c-.09.01-.2.03-.31.03l-.33.02h-.32l-.49-1.08-.48-1.02-.5-1.02-.28-.56-1.5 3.62-.27.03-.31.03c-.11.01-.21.01-.32.01h-.26l-.9-2.39-.79-2.01-.27-.64c-.07-.16-.14-.28-.19-.36a.563.563 0 0 0-.18-.17 1.14 1.14 0 0 0-.23-.05 1.03 1.03 0 0 1-.06-.35c-.03-.14-.03-.27-.03-.41zm46.36 0c0 .12.01.25.02.4l.05.44.07.44c.03.14.06.26.1.37a3.51 3.51 0 0 1-.49.12c-.18.03-.4.05-.67.05a2.76 2.76 0 0 0-.15-.46.858.858 0 0 0-.27-.33 1.16 1.16 0 0 0-.46-.22c-.18-.05-.42-.08-.7-.08h-.56v2.1c.19 0 .35-.01.46-.04.12-.02.21-.06.28-.11s.12-.12.15-.2.04-.19.04-.31c.13-.04.29-.08.48-.09l.53-.02-.03.47-.01.6.01.64.03.46c-.21 0-.4 0-.55-.02a1.43 1.43 0 0 1-.43-.08c-.04-.25-.11-.42-.25-.5s-.38-.12-.72-.12v.99c0 .22.01.39.03.54.03.14.08.25.15.33.06.08.16.14.27.17.12.04.26.05.44.05h.19c.39 0 .7-.1.92-.3.23-.2.42-.52.57-.96.26.02.49.06.7.12a1.64 1.64 0 0 1 .47.2c-.09.22-.16.47-.22.77a8.67 8.67 0 0 0-.13.89c-.17 0-.38 0-.62-.01-.25 0-.5-.01-.77-.01l-.83-.01h-.77l-.81.01-1.07.01-1.01.01-.66.01a5.1 5.1 0 0 1 .02-.4c.01-.13.04-.24.07-.32.15-.01.28-.03.38-.05.1-.03.18-.08.23-.16.06-.08.1-.18.12-.31l.03-.51V18.5c0-.21-.01-.38-.03-.5s-.06-.22-.12-.29-.13-.12-.23-.15-.23-.05-.39-.08c-.03-.09-.05-.21-.06-.35l-.01-.37.64.01.81.01h3.58l.66-.01c.19.01.37 0 .52-.01z",
    fill: "#66502c"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 80.446,
    y1: 22.702,
    x2: 80.446,
    y2: 16.342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8ae2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f5c750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#f2cf65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#f1d373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#f0d577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#9b7729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#fefdf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#faf7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#f5edbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#ede093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#e7ac2a"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.59 16.34a2.92 2.92 0 0 0 .32.01l.43.01h1.48l.59-.03-.01.36c-.01.12-.03.24-.08.36-.16.02-.28.05-.38.09a.42.42 0 0 0-.23.19c-.06.09-.09.22-.11.39l-.03.65v4.23l-.49.07-.6.01-4.06-4.26v2.16c0 .27.01.48.04.65.02.16.07.29.14.38.07.1.17.17.29.2.13.04.28.07.48.09.04.1.06.22.07.34.01.13.01.25.01.37-.09-.01-.19-.01-.31-.01s-.25-.01-.38-.01l-.41-.01H78c-.1 0-.23 0-.38-.01h-.86l-.3.01a3.97 3.97 0 0 1 .02-.38 1.09 1.09 0 0 1 .08-.31 2.34 2.34 0 0 0 .46-.09.69.69 0 0 0 .3-.2.95.95 0 0 0 .16-.38c.04-.17.05-.38.05-.65v-3.1l-.16-.18a.554.554 0 0 0-.26-.18c-.11-.03-.29-.06-.55-.08a1.14 1.14 0 0 1-.08-.33l-.02-.39a2.92 2.92 0 0 0 .32.01 5.89 5.89 0 0 0 .43.01h1.53l.36-.01.29-.01 3.27 3.5v-1.46c0-.26-.01-.48-.04-.64a.728.728 0 0 0-.15-.39c-.07-.1-.18-.16-.31-.2s-.3-.07-.52-.09a1.21 1.21 0 0 1-.07-.36c.02-.1.02-.22.02-.33z",
    fill: "url(#B)"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 70.089,
    y1: 22.702,
    x2: 70.089,
    y2: 16.322
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8ae2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f5c750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#f2cf65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#f1d373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#f0d577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#9b7729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#fefdf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#faf7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#f5edbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#ede093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#e7ac2a"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.26 21.86a.872.872 0 0 1-.25-.1 1.3 1.3 0 0 1-.23-.18l-.24-.3-.45-.6c-.13-.16-.25-.28-.37-.38a1.26 1.26 0 0 0-.39-.22 1.34 1.34 0 0 0-.26-.08l.39-.1c.29-.1.55-.23.76-.39a1.723 1.723 0 0 0 .7-1.43 1.19 1.19 0 0 0-.2-.67c-.13-.21-.33-.4-.6-.55-.27-.16-.61-.28-1.03-.37-.42-.1-.92-.15-1.49-.15l-1.61.03-1.14.02c-.46 0-.89 0-1.28-.01l-1-.03c0 .03.01.08.01.14.01.06.01.13.01.2.01.07.01.14.03.2l.04.17.45.07c.11.04.21.08.27.16a.52.52 0 0 1 .13.29 3.15 3.15 0 0 1 .04.5v2.83c0 .21-.01.38-.04.51-.02.13-.06.23-.13.31-.06.07-.16.12-.27.16a1.72 1.72 0 0 1-.44.05c-.04.08-.06.18-.08.3s-.03.26-.03.42l.99-.02 1.07-.01h.55l.65.01.63.01.48.01-.01-.41a.729.729 0 0 0-.08-.31l-.3-.04c-.08-.02-.14-.07-.2-.15a.955.955 0 0 1-.12-.33 4.75 4.75 0 0 1-.03-.6v-.57h.51l.17.09c.1.06.19.14.27.23a1.11 1.11 0 0 1 .24.31c.08.11.16.27.26.44a8.25 8.25 0 0 1 .39.72l.34.69 1.17-.06 1.87-.02c.09-.23.14-.47.14-.73-.08-.03-.2-.04-.29-.06zm-3.23-3.22a.93.93 0 0 1-.33.25 1.53 1.53 0 0 1-.47.16 3.17 3.17 0 0 1-.53.05c-.06 0-.12 0-.19-.01-.04 0-.11 0-.19-.01V17.4c.17-.04.35-.05.53-.05.4 0 .72.08.96.23a.76.76 0 0 1 .36.68.63.63 0 0 1-.14.38z",
    fill: "url(#C)"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 50.431,
    y1: 22.646,
    x2: 50.431,
    y2: 16.342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8ae2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f5c750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#f2cf65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#f1d373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#f0d577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#9b7729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#fefdf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#faf7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#f5edbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#ede093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#e7ac2a"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.19 17.06h-.02c-.44 0-.77.1-1 .29-.22.19-.4.49-.53.89-.23 0-.45-.01-.66-.02-.22-.02-.41-.05-.58-.12l.12-.41.1-.46c.03-.16.05-.31.06-.47l.03-.43.74.01.79.01h4.34l.82-.01.76-.01c0 .26.03.55.08.86.05.32.12.62.21.89-.16.05-.35.09-.56.12l-.7.04c-.11-.41-.26-.71-.45-.9s-.49-.29-.9-.29h-.24v3.83c0 .21.01.38.05.51.03.13.09.23.17.31.08.07.21.12.35.16.16.03.35.05.6.05.04.08.07.2.09.33a2.77 2.77 0 0 1 .03.39l-.96-.02-1.38-.01h-.8l-.78.01-.7.01-.51.01a1.67 1.67 0 0 1 .04-.37 1.04 1.04 0 0 1 .11-.34l.62-.05c.16-.04.29-.08.39-.16s.16-.18.21-.31a1.78 1.78 0 0 0 .06-.51v-3.83z",
    fill: "url(#D)"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 41.769,
    y1: 22.702,
    x2: 41.769,
    y2: 16.286
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8ae2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f5c750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#f2cf65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#f1d373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#f0d577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#9b7729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#fefdf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#faf7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#f5edbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#ede093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#e7ac2a"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.81 16.29c.55 0 1.04.04 1.47.1.42.07.75.15.97.24l.02.82c.01.27.04.49.07.64-.19.08-.41.12-.7.15a6.83 6.83 0 0 1-.74.04c-.05-.25-.11-.46-.2-.62-.08-.16-.18-.29-.29-.38a.95.95 0 0 0-.39-.19 1.77 1.77 0 0 0-.48-.05c-.23 0-.43.05-.61.14s-.27.23-.27.42c0 .2.1.36.31.49s.47.25.77.36l1.02.34a4.86 4.86 0 0 1 1.01.42 2.52 2.52 0 0 1 .78.62c.21.25.31.55.31.92 0 .3-.09.57-.25.81s-.4.44-.7.62c-.3.17-.65.3-1.05.4a6.1 6.1 0 0 1-1.33.14c-.33 0-.63-.01-.89-.03l-.72-.09c-.22-.04-.43-.09-.63-.16a7.33 7.33 0 0 1-.65-.23c.07-.26.11-.52.13-.79l.04-.78a6.06 6.06 0 0 1 .76-.1l.77-.01c.03.29.06.52.11.71.04.19.11.33.21.44a.85.85 0 0 0 .38.22 2.47 2.47 0 0 0 .6.07c.31 0 .58-.06.78-.17.21-.12.32-.27.32-.46s-.1-.34-.29-.45c-.19-.12-.43-.23-.72-.33l-.95-.33c-.33-.12-.65-.27-.95-.45a2.43 2.43 0 0 1-.72-.67c-.19-.27-.29-.6-.29-1.02a1.24 1.24 0 0 1 .24-.77c.15-.22.37-.4.64-.55a3.69 3.69 0 0 1 .94-.34 4.57 4.57 0 0 1 1.17-.14z",
    fill: "url(#E)"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 33.161,
    y1: 22.646,
    x2: 33.161,
    y2: 16.342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8ae2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f5c750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#f2cf65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#f1d373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#f0d577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#9b7729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#fefdf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#faf7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#f5edbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#ede093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#e7ac2a"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.92 16.34c0 .12.01.25.02.4l.05.44.07.44c.03.14.06.26.1.37-.16.05-.32.09-.49.12-.18.03-.4.05-.67.05a2.76 2.76 0 0 0-.15-.46.79.79 0 0 0-.27-.33 1.16 1.16 0 0 0-.46-.22c-.18-.05-.42-.08-.7-.08h-.56v2.1a1.96 1.96 0 0 0 .46-.04c.12-.02.21-.06.28-.11a.62.62 0 0 0 .15-.2c.03-.08.04-.19.04-.31.13-.04.29-.08.47-.09l.54-.02-.04.47-.01.6.01.64.04.46a8.24 8.24 0 0 1-.55-.02c-.16-.01-.3-.04-.43-.08-.03-.25-.11-.42-.24-.5s-.38-.12-.72-.12v.99c0 .22.01.39.04.53s.08.25.14.33a.52.52 0 0 0 .28.16c.11.04.26.05.44.05h.19c.39 0 .7-.1.92-.29.23-.2.42-.52.57-.97.26.02.49.06.7.12a1.64 1.64 0 0 1 .47.2c-.09.22-.16.47-.22.77l-.14.89c-.17 0-.38 0-.62-.01-.25 0-.5-.01-.77-.01l-.84-.01h-.77l-.82.01-1.06.01-1.01.01-.66.01c0-.14.01-.27.02-.4s.04-.24.07-.32c.15-.01.28-.03.38-.05a.51.51 0 0 0 .24-.16c.06-.08.1-.18.11-.31.02-.13.03-.3.03-.51v-2.81c0-.21-.01-.38-.03-.5a.59.59 0 0 0-.11-.29c-.06-.07-.14-.12-.24-.15s-.23-.05-.39-.07c-.03-.09-.05-.21-.06-.35l-.01-.37.64.01.8.01h3.58l.66-.01.53-.02z",
    fill: "url(#F)"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 21.809,
    y1: 22.702,
    x2: 21.809,
    y2: 16.294
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8ae2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f5c750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#f2cf65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#f1d373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#f0d577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#9b7729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#fefdf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#faf7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#f5edbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#ede093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#e7ac2a"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.46 16.34c.09.01.22.01.4.01l.54.01h1.81l.55-.01.47-.01-.01.38c-.01.12-.04.23-.07.34a1.59 1.59 0 0 0-.4.09c-.09.04-.16.1-.19.18-.04.07-.04.18-.01.31a2.84 2.84 0 0 0 .18.5l.46 1.14.27.71 1.5-3.62c.14-.03.29-.05.46-.06l.47-.01.56 1.14.51 1.06.5 1.08.24.53.6-1.72a3.11 3.11 0 0 0 .15-.58c.01-.16 0-.29-.05-.39a.43.43 0 0 0-.23-.23 1.87 1.87 0 0 0-.43-.12.79.79 0 0 1-.09-.35l-.02-.37c.08.01.17.01.28.01.11.01.23.01.36.01h1.31c.11-.01.22-.01.32-.01l.27-.01a3.9 3.9 0 0 1-.02.36c-.01.12-.03.24-.08.36-.11.03-.19.07-.27.13a.79.79 0 0 0-.23.22c-.07.1-.14.22-.2.38l-.23.6-1.43 4.23c-.06.01-.14.03-.24.03-.09.01-.2.03-.31.03l-.33.02h-.32l-.49-1.08-.48-1.02-.5-1.02-.28-.56-1.5 3.62-.27.03-.31.03c-.11.01-.21.01-.32.01h-.26l-.9-2.39-.79-2.01-.27-.64c-.07-.16-.13-.27-.19-.36a.563.563 0 0 0-.18-.17 1.14 1.14 0 0 0-.23-.05 1.35 1.35 0 0 1-.06-.35l-.02-.41z",
    fill: "url(#G)"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 60.068,
    y1: 22.646,
    x2: 60.068,
    y2: 16.342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8ae2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f5c750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#f2cf65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#f1d373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#f0d577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#9b7729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#fffffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#fefdf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#faf7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#f5edbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#ede093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#ecde8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#f7c240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#e7ac2a"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.83 16.34c0 .12.01.25.02.4l.05.44.07.44c.03.14.06.26.1.37a3.51 3.51 0 0 1-.49.12c-.18.03-.4.05-.67.05a2.76 2.76 0 0 0-.15-.46.79.79 0 0 0-.27-.33 1.16 1.16 0 0 0-.46-.22c-.18-.05-.42-.08-.7-.08h-.56v2.1c.19 0 .35-.01.46-.04.12-.02.21-.06.28-.11s.12-.12.15-.2.04-.19.04-.31c.13-.04.29-.08.48-.09l.53-.02-.03.47-.01.6.01.64.03.46a8.24 8.24 0 0 1-.55-.02c-.16-.01-.3-.04-.43-.08-.04-.25-.11-.42-.25-.5s-.38-.12-.72-.12v.99c0 .22.01.39.04.53s.08.25.15.33c.06.07.15.14.27.16.12.04.26.05.44.05h.19c.39 0 .7-.1.92-.29.23-.2.42-.52.57-.97.26.02.49.06.7.12a1.64 1.64 0 0 1 .47.2c-.09.22-.16.47-.22.77a6.58 6.58 0 0 0-.13.89c-.17 0-.38 0-.62-.01-.25 0-.5-.01-.77-.01l-.83-.01h-.78l-.81.01-1.07.01-1.01.01-.66.01c0-.14.01-.27.02-.4s.04-.24.07-.32c.15-.01.28-.03.38-.05.1-.04.18-.08.23-.16.06-.08.1-.18.12-.31l.03-.51v-2.81c0-.21-.01-.38-.03-.5s-.06-.22-.12-.29-.13-.12-.23-.15-.23-.05-.39-.07c-.03-.09-.05-.21-.06-.35l-.01-.37.64.01.81.01h3.58l.66-.01.52-.02z",
    fill: "url(#H)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanadaWestern);
export default __webpack_public_path__ + "static/media/canada_western.5701464666180ba435f4c12b11391380.svg";
export { ForwardRef as ReactComponent };